<template>
  <div style="background-color:white">
    <el-row style="padding-top:10px">
      <el-col :span="24">
        <div style="float:right;margin-right:30px">
          <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline">

            <el-form-item label="查询日期">
              <el-date-picker v-model="deviceInfo.date" value-format="yyyy-MM-dd HH:mm:ss" type="daterange"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="模糊查询">
              <el-input v-model="deviceInfo.content" auto-complete="off" placeholder="请输入搜索内容"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="getDeviceinfo">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="deviceData" tooltip-effect="dark"
          style="width: 100%;text-align:center" stripe>
          <el-table-column label="序号" type="index" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="userId" label="操作人员账号">
          </el-table-column>
          <el-table-column prop="userName" label="操作人员姓名">
          </el-table-column>
          <el-table-column sortable prop="companyName" label="单位" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="lx" label="记录类型" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="createTime" label="记录时间" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="content" label="操作内容" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="userIp" label="记录IP" show-overflow-tooltip>
          </el-table-column>

        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
        <el-pagination v-if="deviceData.length > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" style="float:right">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { findAllLog, selectAllCompany } from "../../api/api";
export default {
  name: "OperationLog",
  data() {
    return {
      deviceInfo: {
        companyCode: "",
        date: "",
        content: ""
      },
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      multipleTable: [],
      deviceData: [],
      options: [],
      typeOptions: []
    };
  },
  mounted() {
    this.getDeviceinfo();
    this.selectCompany();
  },
  methods: {
    //查找资料信息
    getDeviceinfo() {
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        companyCode: this.deviceInfo.companyCode,
        pageIndex: this.pageIndex,
        pageSize: this.pagesize
      };
      findAllLog(map).then(datas => {
        let { status, message, data } = datas;
         if (status == 200) {
          this.deviceData = data.list;
          this.total = data.total;
          // this.total = data.length;
        } 
      });
    },
    selectCompany() {
      selectAllCompany().then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.options = data;
        } 
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getDeviceinfo();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getDeviceinfo();
    },
  }
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>
<style scoped></style>
  


// WEBPACK FOOTER //
// src/views/SystemSettings/OperationLog.vue